import type { Profile } from "../profile.ts"
import type { Route } from "./+types/layout.tsx"

import { Res } from "@iyk/vf-server"
import { Footer } from "@iyk/vf-ui"
import { Effect } from "effect"
import { Outlet } from "react-router"
import { appConfig } from "../../../app-config.ts"
import { useLang } from "../../../react-router/use-lang.ts"
import { Handler } from "../../../server/handler.ts"
import { Header } from "../ui/header.tsx"
import stylesheet from "../ui/profile.css?url"

export const meta: Route.MetaFunction = () => [
  {
    title: `Profile | ${appConfig.artist.name}`
  },
  {
    property: "og:title",
    content: `Profile | ${appConfig.artist.name}`
  }
]

export const links: Route.LinksFunction = () => [{ rel: "stylesheet", href: stylesheet }]

type LoaderData = {
  user?: Profile.User
}

export const loader = Handler.make<LoaderData>("profile-layout", ({ api, sessions }) => {
  return sessions.authenticated.pipe(
    Effect.flatMap((session) => api.profile(session.user)),
    Effect.orElseSucceed(() => undefined),
    Effect.map((user) => Res.json({ user }))
  )
})

export default function ProfileLayout(props: Route.ComponentProps) {
  const lang = useLang()
  return (
    <div className="max-w-[var(--app-max-width)] w-full mx-auto">
      <div className="relative min-h-dvh flex flex-col text-foreground">
        <div className="absolute inset-0 w-full overflow-hidden select-none h-[calc(100vh*2/3)]">
          <img
            src={appConfig.assets.images.background}
            alt="Profile Background"
            className="size-full object-cover blur-md scale-110"
          />
          <div className="absolute inset-0 size-full bottom-0 left-0 bg-[linear-gradient(to_top,_var(--gray-1),_rgba(0,0,0,0.7))]" />
        </div>
        <Header user={props.loaderData.user} />
        <main className="flex-1 size-full flex flex-col z-10 mt-2">
          <Outlet />
        </main>
        <Footer social={appConfig.socialLinks} lang={lang} />
      </div>
    </div>
  )
}
